import Checkbox from '@/components/Checkbox/Checkbox';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import CustomTooltip from '@/components/ToolTip/CustomTooltip';
import InfoQ from '@/images/InfoQ.svg';
import { useCreateAvatarStore } from '@/pages/avatar/common/context';
import { PremiumPlusCreateAvatarStore } from '@/pages/avatar/PremiumPlusCreatePage/CreateAvatarStore';
import theme from '@/theme';
import styled from '@emotion/styled';
import { tooltipClasses } from '@mui/material/Tooltip';
import { observer } from 'mobx-react-lite';

const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    border: solid;
    border-radius: 8px;
    border-width: 1px;
    border-color: ${theme.colors.black[300]};
    height: 52px;
    padding: 16px 20px 16px 20px;
    margin-top: 8px;
    margin-bottom: 16px;
    cursor: pointer;
`;

const ToolTipText = () => {
    return <span>Removes the green screen.</span>;
};

const StyledToolTip = styled(CustomTooltip)`
    & .${tooltipClasses.tooltip} {
        background-color: ${theme.colors.secondary.main};
    }
    font-size: 0;
`;

const StyledMaskedIcon = styled(MaskedIcon)`
    color: ${theme.colors.grey[500]};
`;

export const GreenScreenSelection = observer(() => {
    const store = useCreateAvatarStore() as PremiumPlusCreateAvatarStore;

    const onClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        store.toggleIsGreenScreen();
    };

    return (
        <Container onClick={onClick}>
            <Checkbox checked={store.isGreenScreen} onClick={onClick} />
            My footage has a green screen
            <StyledToolTip cursor="pointer" title={<ToolTipText />} placement="top">
                <StyledMaskedIcon src={InfoQ} size="16px" />
            </StyledToolTip>
        </Container>
    );
});
